<template>
  <Modal :activeModal="activeModal" @closeModal="closeModal">
    <template v-slot:btnActivator>
      <v-btn
        tile
        :color="variables.colorPrimary"
        dark
        class="mb-2 modal-cadastro-btn-cadastrar"
        @click="openModal"
        :loading="loadingBtnCadastro">Novo cadastro</v-btn>
    </template>
    <v-card>
      <v-toolbar flat height="40px" class="modal-cadastro-toolbar">
          {{ isEdit ? `Editar Plano: ${item.name} ` : 'Cadastrar Plano' }}
          <v-spacer></v-spacer>
          <v-icon @click="closeModal" class="modal-cadastro-close">close</v-icon>
      </v-toolbar>

      <v-form>
        <v-card-text class="modal-cadastro-form">
            <v-row>
              <!-- Tipos de contratos -->
              <v-col cols="6" class="modal-cadastro-form-col-imput mt-2 my-3">
                <v-text-field class="contrato" :error-messages="nomeErrors" v-model="item.name" type="text" label="Nome do Plano:" placeholder="Nome"  @input="$v.item.name.$touch()" @blur="$v.item.name.$touch()" />
              </v-col>

            <v-col cols="12" class="pt-0">
              <v-row>  
                <!-- Level -->
                <v-col class="modal-cadastro-form-col-imput">
                  <v-text-field
                    v-model="itemValueRange.level"
                    readonly
                    dense
                    label="Level"
                    class="input-level"
                    type="number"
                    @input="$v.itemValueRange.level.$touch()"
                  />
                </v-col>
  
                <!-- aliquot -->
                <v-col class="modal-cadastro-form-col-imput">
                  <v-currency-field v-model="itemValueRange.aliquot" label="Alíquota:" prefix="%" dense @input="$v.itemValueRange.aliquot.$touch()" @blur="$v.itemValueRange.aliquot.$touch()" ref="aliquotInput" />
                </v-col>
                
                <v-col cols="12" class="modal-cadastro-form-col-imput" sm="3">
                  <v-btn :color="variables.colorPrimary" @click.prevent="clearRange" class="mr-2" dark>Limpar</v-btn>
                  <v-btn :color="variables.colorSecondary" @click.prevent="addRange()" dark>Add</v-btn>
                </v-col>
              </v-row>
            </v-col>

            <!-- tabela level:aliquot -->
            <v-col>
              <v-card-text>
                <v-layout column style="height: 40vh">
                <v-flex style="overflow: auto">
                <v-data-table
                  :headers="headers"
                  :items="listLancamentoRangeValores"
                  :loading="loadingTableValues"
                  flat
                  hide-default-footer
                  :itemsPerPage="999"
                  dense>
                  <template v-slot:body="{ items }">
                    <tbody> 
                      <tr v-for="(item, index) in items" :key="index" >
                        <td>{{ item.level }}</td>
                        <td>{{ item.aliquot || 0 }}%</td>
                        <td>
                          <v-icon small class="mr-2" @click.prevent="editValue(index)" > edit </v-icon>
                        </td>
                        <td v-if="canDeleteItem(item)">
                          <v-icon small @click="deleteRange(index)">delete</v-icon>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-data-table>
                </v-flex>
                </v-layout>
              </v-card-text>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions class="modal-cadastro-footer">
          <v-btn tabindex="7" :color="variables.colorPrimary" @click="closeModal" class="br-btn br-btn-cancelar">Cancelar</v-btn>
          <v-btn tabindex="6" type="submit" :color="variables.colorPrimary" @click.prevent="cadastroPlano()" class="br-btn" :loading="loading">{{ isEdit ? 'Salvar' : 'Cadastrar' }}</v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </Modal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { validationMixin } from 'vuelidate'
// eslint-disable-next-line
import { maxValue, minValue, required } from 'vuelidate/lib/validators'
import { mask } from 'vue-the-mask'
import Events from '@/core/service/events'
import variables from '@/assets/styles/helpers/_variables.scss'

// eslint-disable-next-line
import { map, filter, size } from 'lodash'
import { errorSnackbar, successSnackbar } from '@/core/service/utils'
import validacao from './validacao'
// eslint-disable-next-line
export default {
  name: 'ModalCadastroPlanosAfiliado',
  mixins: [validationMixin],
  directives: {mask},

  components: {
    Modal: () => import('@/views/components/modal'),
  },

  data: () => ({
    loadingTableValues: false,
    levelValue: 1,
    activeModal: false,
    loading: false,
    showPassword: false,
    loadingBtnCadastro: false,
    loadingModal: false,
    tab: null,
    tabComission: null,
    editValues: false,
    typeComissionREC: {},
    headers: [
      { align: 'start', class: 'table-header', text: 'Level', value: 'level', sortable: false },
      { align: 'start', class: 'table-header', text: 'Alicota:', value: 'aliquot', sortable: false },
      { align: 'end', class: 'table-header', text: '', value: 'action', sortable: false },
    ]
  }),
  
  watch: {
    'itemValueRange.aliquot' (val) {
      if (val > 100) this.$nextTick(() => { this.itemValueRange.aliquot = 100 })
    }
  },

  computed: {
    ...mapGetters('AffiliateReferenceComissionPlans', ['item', 'listaTypesContract', 'listTipeSelectContrato', 'listTipeSelectComission', 'itemValueRange', 'listLancamentoRangeValores']),
    ...mapGetters('roles', ['permiteAcao']),
    ...validacao,
    variables: () => variables,
    isEdit () {
      return this.item.id ? !!1 : !!0
    },
  },
  mounted () {
    Events.$on('cadastro::openModalCadastro', (dados) => {
      this.openModal(dados)
    })
  },
  methods: {
    ...mapActions('AffiliateReferenceComissionPlans', ['cadastrarItem', 'editarItem', 'limparItem', 'clearModal', 'getItens']),
    /* range de valores */
    ...mapActions('AffiliateReferenceComissionPlans', ['addRangeValues', 'editValuesRange', 'deleteValueRange', 'clearValueRange', 'listValueRange']),

    deleteOperator (idx) {
      this.deleteTypeOperator(idx)
      this.clearTypeOperator()
      this.$v.itemOperator.$reset()
    },

    /* Values Ranges */
    async addRange () {
      await this.addRangeValues(this.itemValueRange)
        this.$refs.aliquotInput.$el.querySelector('input').focus()
    },

    clearOperator () {
      this.clearTypeOperator()
    },

    editValue (idx) {
      this.$refs.aliquotInput.$el.querySelector('input').focus()
      this.editValues = idx
      this.editValuesRange(idx)
    },

    deleteRange (idx) {
      this.deleteValueRange(idx)
      this.itemValueRange.level -= 1
      this.clearRange()
    },

    clearRange () {
      this.clearValueRange()
    },

    async openModal (dados) {
      this.clearModal()
      this.activeModal = true
      if (dados && dados.referenceComissionValues) {
        this.item.id = dados.id
        const sortedValues = dados.referenceComissionValues.sort((a, b) => a.level - b.level)

        this.listLancamentoRangeValores = await Promise.all(sortedValues.map(async element => {
          await this.listValueRange({ ...element })
        }))
      }
    },

    cadastroPlano() {
      if (this.$v.item.$invalid) {
        this.$v.item.$touch()
        return false 
      }

      this.loading = true
      // valores
      this.item.listValues = map(this.listLancamentoRangeValores, v => {
        return {
          ...v
        }
      })

      this.cadastrarItem(this.item).then(() => {
        successSnackbar('Cadastro realizado com sucesso!')
        this.closeModal()
        Events.$emit('reload::table::index')
      }).catch(err => errorSnackbar(err.error))
      .finally(() => {
        this.loading = false
      })
    },

    closeModal () {
      this.activeModal = false
      this.limparItem()
      this.clearModal()
      this.$v.item.$reset()
    },
    canDeleteItem(item) {
      // Verifica se o item é o nível mais alto
      const highestLevel = this.getHighestLevel()
      return item.level === highestLevel
    },
    getHighestLevel() {
      // Lógica para obter o level mais alto
      const levels = this.listLancamentoRangeValores.map((item) => item.level)
      return Math.max(...levels)
    },
  },

  validations () {
    return  {
      itemValueRange: {
        aliquot: { required },
          level: { required }
      },
      item: {
        name: { required }
      },
    }
  }
}

</script>

<style lang="scss" scoped>
  @import '../../../../assets/styles/components/formularios';
  @import '../../../../assets/styles/components/modal-cadastro';
  // .modal-cadastro-form . {
  //   border: 1px solid black;
  //   padding: 5px;
  //   border-radius: 10px;
  // }

.input-level {
  text-align-last: center;
}

table tbody tr td span {
  background: cadetblue;
  width: 50px;
  border-radius: 10px;
  min-width: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  font-weight: bold;
  font-size: 18px;
  &:hover {
    opacity: 0.8;
  }
}
.contrato {
  margin: 0 !important;
  padding: 0 !important;
}
</style>